import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LiveBar from "./components/LiveBar";
import HotRank from "./components/HotRank";
import CategorySection from "./components/CategorySection";
import DeepFeed from "./components/DeepFeed";
import Features from "./components/Features";
import Voices from "./components/Voices";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 text-background-50 shadow-lg transition-all ${show ? "opacity-100" : "pointer-events-none opacity-0"}`}>
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "爆瓜台的“直播爆料”和普通图文新闻有什么不同？",
      acceptedAnswer: { "@type": "Answer", text: "爆瓜台的核心是“在线瓜场”。一个瓜爆出后，主播会立刻开启直播，带着滚动的时间线、路透图和弹幕一起实时复盘，你可以边看边刷进度条，也可以随时开麦发表看法，真正做到“不用等明天，爆料到达端口即用”。" },
    },
    {
      "@type": "Question",
      name: "瓜的信息来源可靠吗？会不会吃到假瓜？",
      acceptedAnswer: { "@type": "Answer", text: "我们坚持“多方交叉核实”的内容原则：每一个进入直播的瓜都要经过线索捕捉、现场比对和多方回应三个阶段。标注“LIVE”的为实时跟进现场，标注“复盘”的为已经过多方信息交叉确认的总结。" },
    },
    {
      "@type": "Question",
      name: "围观直播需要付费吗？",
      acceptedAnswer: { "@type": "Answer", text: "绝大多数吃瓜直播间完全免费，直接点开即可进入围观和参与弹幕。仅有极少数制作投入特别大的“幕后探访”专题需要解锁。" },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.text = JSON.stringify(faqSchema);
    document.head.appendChild(s);
    return () => { document.head.removeChild(s); };
  }, []);

  return (
    <div className="w-full">
      <Navbar />
      <main>
        <Hero />
        <LiveBar />
        <HotRank />
        <CategorySection />
        <DeepFeed />
        <Features />
        <Voices />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}